import React from 'react';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useSelector } from 'react-redux';

function renderSwitch(status, locales) {
        //Υποβολή Αίτησης
        if(status === 'task.name.submit_application')
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_SUBMISSION)}</span></div>;
        //Επιστροφή στον Ωφελούμενο
        else if(status === 'task.name.application_returned_to_supplier')
            return <div className="application-badge audit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_RETURNED_TO_SUPPLIER)}</span></div>; 
        //Προς Αξιολόγηση
        else if(status === 'task.name.audit_application')
            return <div className="application-badge audit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION)}</span></div>; 
        //Αξιολόγηση από ΦΥ
        else if(status === 'task.name.application_evaluation_by_auditor')
            return <div className="application-badge audit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION_BY_AUDITOR)}</span></div>; 
        //Απόρριψη Αξιολόγησης
        else if(status === 'task.name.temporary_rejected')
            return <div className="application-badge reject-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTED)}</span></div>; 
        //Έγκριση Αξιολόγησης
       else if(status === 'task.name.accepted')
            return <div className="application-badge evaluate-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_ACCEPTED)}</span></div>;
       //Προς Αξιολόγηση από Επιτροπή
        else if(status === 'task.name.application_evaluation_before_committee')
            return <div className="application-badge audit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION_BEFORE_COMMITTEE)}</span></div>; 
       //Αξιολόγησης EE
       else if(status === 'task.name.application_evaluation_by_committee')
            return <div className="application-badge purple"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION_BY_COMMITTEE)}</span></div>;
       //Τελικώς Απορριφθείσα
       else if(status === 'task.name.final_rejected')
            return <div className="application-badge reject-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_FINAL_REJECTED)}</span></div>;
        //Εκδοση προσωρινής Κατάταξης
        else if(status === 'task.name.issuance_of_provisional_classification')
            return <div className="application-badge purple"><span>{getLocalString(locales, localNames.TASK_NAME_ISSUANCE_OF_PROVISIONAL_CLASSIFICATION)}</span></div>;
        //Υποβολή Ένστασης
        else if(status === 'task.name.objection_submission')
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_OBJECTION_SUBMISSION)}</span></div>; 
        //Αξιολόγηση ΕΕ
        else if(status === 'task.name.objection_evaluation')
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_OBJECTION_EVALUATION)}</span></div>;
        //Αξιολόγηση Ενστάσεων - Απόρριψη Ένστασης
        else if(status === 'task.name.application_rejection')
            return <div className="application-badge red"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTION)}</span></div>; 
        //Εκδοση τελικής Κατάταξης
        else if(status === 'task.name.final_classification')
            return <div className="application-badge purple"><span>{getLocalString(locales, localNames.TASK_NAME_FINAL_CLASSIFICATION)}</span></div>;
        //ακύρωση Αίτησης
        else if(status === 'task.name.cancelled_task')
            return <div className="application-badge cancel-badge"><span>{getLocalString(locales, localNames.TASK_NAME_CANCEL)}</span></div>; 
        else if(status === 'task.name.program_implementation')
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.REQUEST_STATUS_PROGRAMIMPLEMENTATION)}</span></div>;
        else if(status === 'APPROVED')
            return <div className="application-badge evaluate-badge"><span>Εγκρίθηκε</span></div>;
        else if(status === 'REJECTED')
            return <div className="application-badge reject-badge"><span>Απορρίφθηκε</span></div>;
        else if(status === 'PENDING_REVIEW')
            return <div className="application-badge orange"><span>Υπό Αξιολόγηση</span></div>;
        else
            return null;
    
}

const StatusTag = props => {
  const locales = useSelector(state => state.forms?.localeStrings);
  return renderSwitch(props.status, locales);
};

export default StatusTag;
